import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const COPY_TASK_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
